<template>
  <section id="testimonials" class="">
    <div class="hero-image">
      <img src="../../static/static-css/img/about-us/about.jpg" alt />
      <div class="overlay"></div>
    </div>
    <div class="container">
      <div class="dasboard-content">
        <div class="tittle text-left">
          <h3 class="mb-3">Testimonials</h3>
          <p class="subtittle">Unfortunately, no testimonials are available currently.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created () {
    this.$store.commit('ISLOADING', false)
  }
}
</script>

<style>
.dasboard-content
  .content
  .carousel
  .testimonial-actions
  .left.carousel-control {
  background-image: url("../assets/images/icon/arrow-left-50.png") !important;
  width: 68px !important;
  height: 40px !important;
}
#testimonials
  .dasboard-content
  .content
  .carousel
  .testimonial-actions
  .right.carousel-control {
  background-image: url("../assets/images/icon/right-arrow-50.png") !important;
  width: 68px !important;
  height: 40px !important;
}
.hero-image {
  position: relative;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0,0,0,0.5);
}

.hero-image img {
  max-height: 500px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Testimonials.vue